import React from 'react'
// import {Provider} from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
import configureStore, { history, apolloClient } from './redux/configureStore'
import { ApolloProvider, } from 'react-apollo'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import SellingPage from './components/pages/Selling'
import OrderLinesPage from './components/pages/Selling-Order'
import ProductVariationsPage from './components/pages/Selling-Order-Variations'
import VariationDetailsPage from './components/pages/Selling-Order-Variation-Details'
import ProducerPage from './components/pages/Production'
import DailyAmountReport from './components/pages/Reports'
// import logo from './logo.svg';
import './App.css'
// import 'react-select/dist/react-select.css';
import MainMenuComponent from './components/container/MainMenu'

const store = configureStore()
// Now you can dispatch navigation actions from anywhere!
// store.dispatch(push('/foo'))
const App = () => (
  <MuiThemeProvider>
    <div className="App">
      { /* ConnectedRouter will use the store from Provider automatically */}
      <ApolloProvider client={apolloClient} store={store}>
        <ConnectedRouter history={history}>
          <div>
            <MainMenuComponent />
            <Route exact path="/" component={SellingPage}/>
            {/*<Route path="/order/:id" component={OrderPage} />*/}
            <Route exact path="/order/:id" component={OrderLinesPage}/>
            <Route exact path="/order/:id/lines/:lineId" component={ProductVariationsPage}/>
            <Route exact path="/order/:id/lines/:lineId/details" component={VariationDetailsPage}/>
            <Route exact path="/producer" component={ProducerPage}/>
            <Route exact path="/reports/dailyamount" component={DailyAmountReport}/>
            {/*<Route path="/about" component={About}/>*/}
            {/*<Route path="/topics" component={Topics}/>*/}
          </div>
        </ConnectedRouter>
      </ApolloProvider>
    </div>
  </MuiThemeProvider>
)

export default App




// WEBPACK FOOTER //
// ./src/App.js